/**
 * @generated SignedSource<<894f0475d89546b8f8ba914dd859e916>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SpaceViewsPersistenceOption = "POPULARITY" | "RECENTLY_MODIFIED" | "RECENTLY_VIEWED" | "TITLE_AZ" | "TREE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment$data = {
  readonly __typename: "UserPreferences";
  readonly spaceViewsPersistence: SpaceViewsPersistenceOption;
  readonly " $fragmentType": "useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment";
};
export type useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment$key = {
  readonly " $data"?: useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "spaceKey"
    }
  ],
  "kind": "Fragment",
  "name": "useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "spaceKey",
          "variableName": "spaceKey"
        }
      ],
      "kind": "ScalarField",
      "name": "spaceViewsPersistence"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "9ec903133829a75826057a66a4a62727";

export default node;
